import { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { storage, type ExternalGuestIdentity } from '../lib/storage';

interface SessionContextValue {
  profile: ExternalGuestIdentity | null;
  hydrated: boolean;
  setProfile: (profile: ExternalGuestIdentity) => void;
  clearProfile: () => void;
}

const AppSessionContext = createContext<SessionContextValue | null>(null);

export function AppSessionProvider({ children }: { children: React.ReactNode }) {
  const [profile, setProfileState] = useState<ExternalGuestIdentity | null>(() => storage.getProfile());
  const hydrated = true;

  const setProfile = useCallback((next: ExternalGuestIdentity) => {
    storage.setProfile(next);
    setProfileState(next);
  }, []);

  const clearProfile = useCallback(() => {
    storage.clearProfile();
    setProfileState(null);
  }, []);

  const value = useMemo(() => ({ profile, hydrated, setProfile, clearProfile }), [profile, setProfile, clearProfile]);
  return <AppSessionContext.Provider value={value}>{children}</AppSessionContext.Provider>;
}

export function useAppSession() {
  const ctx = useContext(AppSessionContext);
  if (!ctx) throw new Error('useAppSession must be used inside AppSessionProvider');
  return ctx;
}
